import actionsTypes from '../constants/actionTypes';
import axios from 'axios';
import {
  USERS_API_URL,
  HOME_PAGE,
  SUCCESSFUL_CHARGE,
  ACTIVE_SUBSCRIPTION,
  CANCELED_SUBSCRIPTION,
  CANCEL_PLAN_IMMEDIATELY
} from '../constants'
import { push } from 'react-router-redux';
import alertTypes from '../constants/alertTypes';
import { updateLocalStorageSession, parseError } from "../utils";
import _ from 'lodash';

/* ACTIONS */

const updateThemeAction = (theme) => {
  return {
    type: actionsTypes.UPDATE_THEME,
    payload: theme
  }
};

const updateFontSizeAction = (fontSize) => {
  return {
    type: actionsTypes.UPDATE_FONT_SIZE,
    payload: fontSize
  }
};

const updateTranscriptionAction = (payload) => {
  return {
    type: actionsTypes.UPDATE_TRANSCRIPTION,
    payload: payload
  }
};

const updateTranslationAction = (payload) => {
  return {
    type: actionsTypes.UPDATE_TRANSLATION,
    payload: payload
  }
};

const updateSessionAction = (payload) => {
  return {
    type: actionsTypes.UPDATE_SESSION,
    payload: payload
  }
};

const updateCustomerAction = (payload) => {
  return {
    type: actionsTypes.UPDATE_CUSTOMER,
    payload: payload
  }
};

const updateProfileAction = (payload) => {
  return {
    type: actionsTypes.UPDATE_PROFILE,
    payload: payload
  }
};

const updateIsProfileSyncedAction = (payload) => {
  return {
    type: actionsTypes.UPDATE_IS_PROFILE_SYNCED,
    payload: payload
  }
};

const updateIsCustomerSyncedAction = (payload) => {
  return {
    type: actionsTypes.UPDATE_IS_CUSTOMER_SYNCED,
    payload: payload
  }
};

const handleAlertAction = (payload) => {
  return {
    type: actionsTypes.HANDLE_ALERT,
    payload: payload
  }
};

/* ACTION CREATORS */
const handleAuthentication = (authResult) => {

  return (dispatch) => {
    const accessToken = authResult.accessToken;
    const expiresAt = authResult.expiresIn * 1000 + new Date().getTime();
    updateLocalStorageSession({accessToken, expiresAt});
    dispatch(updateSessionAction({accessToken, expiresAt}));
    dispatch(push(HOME_PAGE));
  }
};

const handleAuthenticationError = (error) => {
  return (dispatch) => {
    updateLocalStorageSession({accessToken: null, expiresAt: null});
    dispatch(updateSessionAction({accessToken: null, expiresAt: null}));
    dispatch(push(HOME_PAGE));
    dispatch(handleAlertAction({
      type: alertTypes.ERROR,
      message: error.message
    }));
  }
};

const handleLogout = () => {
  return (dispatch) => {
    updateLocalStorageSession({accessToken: null, expiresAt: null});
    dispatch(updateSessionAction({accessToken: null, expiresAt: null}));
    dispatch(push(HOME_PAGE));
  }
};


const getProfile = (accessToken) => {

  return (dispatch) => {

    dispatch(updateIsProfileSyncedAction(false));
    const url = `${USERS_API_URL}/user/profile`;
    const config = {
      method: 'get',
      headers: {
        Accept: "application/json",
        Authorization: 'Bearer ' + accessToken
      }
    };

    return axios(url, config).then((response) => {

      dispatch(updateProfileAction(response.data.message));
      dispatch(updateIsProfileSyncedAction(true));

    }).catch(function (error) {

      const {message, clearSession} = parseError(error);
      if (message !== null) {
        dispatch(handleAlertAction({type: alertTypes.ERROR, message}));
      }
      if (clearSession) {
        updateLocalStorageSession({accessToken: null, expiresAt: null});
        dispatch(updateSessionAction({accessToken: null, expiresAt: null}));
        dispatch(push(HOME_PAGE));
      }
      dispatch(updateIsProfileSyncedAction(true));
    });
  };
};



const patchProfile = (accessToken, payload) => {

  return (dispatch) => {

    dispatch(updateIsProfileSyncedAction(false));

    const url = `${USERS_API_URL}/user/profile`;
    const config = {
      method: "patch",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + accessToken
      }, data: payload
    };

    return axios(url, config).then((response) => {

      dispatch(updateProfileAction(response.data.message));
      dispatch(updateIsProfileSyncedAction(true));

    }).catch(function (error) {

      const {message, clearSession} = parseError(error);
      if (message !== null) {
        dispatch(handleAlertAction({type: alertTypes.ERROR, message}));
      }
      if (clearSession) {
        updateLocalStorageSession({accessToken: null, expiresAt: null});
        dispatch(updateSessionAction({accessToken: null, expiresAt: null}));
        dispatch(push(HOME_PAGE));
      }
      dispatch(updateIsProfileSyncedAction(true));
    });
  }
};


const handleAlert = (payload) => {
  return (dispatch) => {
    dispatch(handleAlertAction(payload))
  }
};


const getCustomer = (accessToken) => {

  return (dispatch) => {

    dispatch(updateIsCustomerSyncedAction(false));

    const url = `${USERS_API_URL}/user/customer`;
    const config = {
      method: 'get',
      headers: {
        Accept: "application/json",
        Authorization: 'Bearer ' + accessToken
      }
    };

    return axios(url, config).then((response) => {
      dispatch(updateCustomerAction(response.data));
      dispatch(updateIsCustomerSyncedAction(true));
    }).catch(function (error) {
      const {message, clearSession} = parseError(error);
      if (message !== null) {
        dispatch(handleAlertAction({type: alertTypes.ERROR, message}));
      }
      if (clearSession) {
        updateLocalStorageSession({accessToken: null, expiresAt: null});
        dispatch(updateSessionAction({accessToken: null, expiresAt: null}));
        dispatch(push(HOME_PAGE));
      }
      dispatch(updateIsCustomerSyncedAction(true));
    });
  };
};

const createSubscription = (accessToken, stripeToken, planId, customerId) => {

  return dispatch => {

    dispatch(updateIsCustomerSyncedAction(false));

    const onSuccess = (data) => {
      const customer = _.get(data, 'data.customer');
      dispatch(updateCustomerAction(customer));
      dispatch(updateIsCustomerSyncedAction(true));

      const status = _.get(data, 'data.subscription.status');
      if (status === ACTIVE_SUBSCRIPTION) {
        dispatch(handleAlertAction({
          type: alertTypes.SUCCESS,
          message: 'Payment successful.'
        }))
      } else {
        dispatch(handleAlertAction({
          type: alertTypes.ERROR,
          message: 'Payment error. Please try again.'
        }))
      }
    };

    const onError = (error) => {
      const {message} = parseError(error);
      if (message !== null) {
        dispatch(handleAlertAction({type: alertTypes.ERROR, message}));
      }
      dispatch(updateIsCustomerSyncedAction(true));
    };

    const url = `${USERS_API_URL}/user/subscription`;
    const config = {
      method: 'post',
      headers: {
        Accept: "application/json",
        Authorization: 'Bearer ' + accessToken
      },
      data: {
        planId: planId,
        stripeToken: stripeToken.id,
        stripeCustomerId: customerId
      }
    };

    return axios(url, config).then(onSuccess).catch(onError);
  }
};

const deleteSubscription = (accessToken, subscriptionId) => {
  return dispatch => {

    dispatch(updateIsCustomerSyncedAction(false));

    const onSuccess = (data) => {
      const customer = _.get(data, 'data.customer');
      dispatch(updateCustomerAction(customer));
      dispatch(updateIsCustomerSyncedAction(true));

      const status = _.get(data, 'data.subscription.status');
      if (status === CANCELED_SUBSCRIPTION) {
        dispatch(handleAlertAction({
          type: alertTypes.SUCCESS,
          message: 'Subscription successfully cancelled.'
        }))
      } else {
        dispatch(handleAlertAction({
          type: alertTypes.ERROR,
          message: 'There was an error. Please try again.'
        }))
      }
    };

    const onError = (error) => {
      const {message} = parseError(error);
      if (message !== null) {
        dispatch(handleAlertAction({type: alertTypes.ERROR, message}));
      }
      dispatch(updateIsCustomerSyncedAction(true));
    };

    const url = `${USERS_API_URL}/user/subscription`;
    const config = {
      method: 'delete',
      headers: {
        Accept: "application/json",
        Authorization: 'Bearer ' + accessToken
      },
      data: {
        subscriptionId: subscriptionId,
        atPeriodEnd: !CANCEL_PLAN_IMMEDIATELY
      }
    };

    return axios(url, config).then(onSuccess).catch(onError);
  }
};

const createCharge = (accessToken, stripeToken, paymentId, customerId,
                      description, amount, currency) => {

  return dispatch => {

    dispatch(updateIsCustomerSyncedAction(false));

    const onSuccess = (data) => {
      const customer = _.get(data, 'data.customer');
      dispatch(updateCustomerAction(customer));
      dispatch(updateIsCustomerSyncedAction(true));

      const status = _.get(data, 'data.charge.status');
      if (status === SUCCESSFUL_CHARGE) {
        dispatch(handleAlertAction({
          type: alertTypes.SUCCESS,
          message: 'Payment successful.'
        }))
      } else {
        dispatch(handleAlert({
          type: alertTypes.ERROR,
          message: 'Payment error. Please, try again.'
        }));
      }

    };

    const onError = (error) => {
      const {message} = parseError(error);
      if (message !== null) {
        dispatch(handleAlert({type: alertTypes.ERROR, message}));
      }
      dispatch(updateIsCustomerSyncedAction(true));
    };

    const url = `${USERS_API_URL}/user/charge`;

    const config = {
      method: 'post',
      headers: {
        Accept: "application/json",
        Authorization: 'Bearer ' + accessToken
      },
      data: {
        amount: amount,
        currency: currency,
        description: `[${paymentId}]` + (description || ''),
        stripeToken: stripeToken.id,
        stripeCustomerId: customerId
      }
    };

    return axios(url, config).then(onSuccess).catch(onError);
  }

};

function updateTheme(theme) {
  return dispatch => {
    dispatch(updateThemeAction(theme));
  }
}

function updateFontSize(fontSize) {
  return dispatch => {
    dispatch(updateFontSizeAction(fontSize));
  }
}

function updateTranscription(payload) {
  return dispatch => {
    dispatch(updateTranscriptionAction(payload));
  }
}

function updateTranslation(payload) {
  return dispatch => {
    dispatch(updateTranslationAction(payload));
  }
}

function sendEmailVerification(accessToken) {


  return dispatch => {

    const onSuccess = () => {
      dispatch(handleAlert({
        type: alertTypes.SUCCESS,
        message: 'We sent you a verification email.'
      }));
    };

    const onError = () => {
      dispatch(handleAlert({
        type: alertTypes.ERROR,
        message: 'Error sending verification email.'
      }));
    };


    const url = `${USERS_API_URL}/user/verification-email`;

    const config = {
      method: 'post',
      headers: {
        Accept: "application/json",
        Authorization: 'Bearer ' + accessToken
      }
    };

    return axios(url, config).then(onSuccess).catch(onError);
  }
}

const goTo = (url) => {
  return (dispatch) => {
    dispatch(push(url));
  }
};

export {
  handleLogout,
  handleAuthentication,
  handleAuthenticationError,
  getCustomer,
  getProfile,
  patchProfile,
  handleAlert,
  createSubscription,
  deleteSubscription,
  createCharge,
  updateTheme,
  updateFontSize,
  updateTranscription,
  updateTranslation,
  sendEmailVerification,
  goTo
}



// WEBPACK FOOTER //
// ./src/actions/index.js